import NrButton from '../NrButton/nr-button.vue';
import NrIconButton from '../NrIconButton/nr-icon-button.vue';
import NrTooltip from '../NrTooltip/NrTooltip.vue';
import truncate from 'lodash/truncate';
export default {
  name: 'MessageBox',
  components: {
    NrButton: NrButton,
    NrIconButton: NrIconButton,
    NrTooltip: NrTooltip
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    submitText: {
      type: String,
      default: 'Submit'
    },
    type: {
      type: String,
      default: 'default'
    },
    disableSubmit: {
      type: Boolean,
      default: false
    },
    submitTooltipText: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      minimized: false,
      expanded: false,
      fullview: false,
      currentState: 'expanded'
    };
  },
  computed: {
    truncatedTitle: function truncatedTitle() {
      var length = this.minimized ? 20 : 50;
      return truncate(this.title, {
        length: length
      });
    }
  },
  methods: {
    handleMinimize: function handleMinimize() {
      if (this.currentState === 'minimized') {
        this.handleExpand();
        return;
      }
      this.minimized = true;
      this.expanded = false;
      this.fullview = false;
      this.currentState = 'minimized';
    },
    handleExpand: function handleExpand() {
      if (this.minimized) {
        this.fullview = false;
        this.minimized = false;
        this.expanded = true;
        this.currentState = 'expanded';
      } else {
        this.fullview = true;
        this.minimized = false;
        this.expanded = false;
        this.currentState = 'fullview';
      }
    },
    handleUnexpand: function handleUnexpand() {
      this.fullview = false;
      this.minimized = false;
      this.expanded = true;
    },
    handleView: function handleView() {
      if (this.minimized) {
        return 'message-box-container-minimized';
      } else if (this.fullview) {
        return 'message-box-container-fullview';
      } else if (this.expanded) {
        return 'message-box-container';
      } else {
        return 'message-box-container';
      }
    }
  }
};